import { Icon, Text } from '@/components';
import { FC } from 'react';

interface Props {
  label?: string;
  setCursorToPointer?: boolean;
  onBackClick?: () => void;
  className?: string;
}

const BackButton: FC<Props> = ({
  label = '',
  setCursorToPointer = true,
  onBackClick,
  className = '',
}) => {
  return (
    <div
      className={`inline-flex items-center ${
        setCursorToPointer ? 'cursor-pointer' : ''
      } ${className}`}
      onClick={onBackClick}
    >
      <Icon name="chevronLeft" intent="accent" />
      {label && <Text value={label} color="accent" />}
    </div>
  );
};

export default BackButton;
